(function () {
  'use strict';
  if (window.DeckauraFunnelDelivery) return;

  var ENDPOINT = 'https://reading.deckaura.com/funnel-events';
  var STORAGE_KEY = 'deckaura_funnel_outbox_v1';
  var MAX_EVENTS = 50;
  var MAX_ATTEMPTS = 3;
  var MAX_AGE_MS = 24 * 60 * 60 * 1000;
  var FREE_TAROT_PAGE = '/pages/free-tarot-reading';
  var FREE_TAROT_VALUE_EVENTS = {
    result_view: true,
    free_answer_view: true,
    primary_cta_view: true,
    cta_click: true,
    checkout_handoff: true
  };
  var timer = 0;
  var active = false;
  var EVENT_KEYS = {
    eventId: true, eventName: true, conversationId: true, readingId: true, page: true,
    readingMode: true, funnelVersion: true, experimentKey: true, experimentVariant: true,
    recommendedTier: true, selectedTier: true, shopifyVariantId: true, metadata: true, occurredAt: true
  };
  var PRIVATE_METADATA_KEYS = {
    question: true, email: true, answer: true, reading_text: true, card_name: true,
    prompt: true, context: true, full_name: true, first_name: true, last_name: true,
    birth_date: true, date_of_birth: true, phone: true, message: true
  };

  function sanitizeEvent(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input)) return null;
    var output = {};
    Object.keys(input).forEach(function (key) {
      if (!EVENT_KEYS[key] || key === 'metadata') return;
      var value = input[key];
      if (value === null || value === undefined) return;
      if (typeof value === 'string') output[key] = value.slice(0, 240);
      else if (typeof value === 'number' && Number.isFinite(value)) output[key] = value;
      else if (typeof value === 'boolean') output[key] = value;
    });
    var metadata = input.metadata;
    output.metadata = {};
    if (metadata && typeof metadata === 'object' && !Array.isArray(metadata)) {
      Object.keys(metadata).slice(0, 40).forEach(function (key) {
        if (PRIVATE_METADATA_KEYS[String(key).toLowerCase()]) return;
        var value = metadata[key];
        if (typeof value === 'string') output.metadata[key] = value.slice(0, 160);
        else if (typeof value === 'number' && Number.isFinite(value)) output.metadata[key] = value;
        else if (typeof value === 'boolean') output.metadata[key] = value;
      });
    }
    return output;
  }

  function normalizeEvent(event) {
    if (!event || typeof event !== 'object') return event;
    var metadata = event.metadata;
    if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return event;

    // The API manifest is case-sensitive even when a legacy producer is not.
    if (event.page === FREE_TAROT_PAGE && event.readingMode === 'shared_tool') {
      metadata.tool_type = 'Tarot';
    }

    // A visible answer/offer on this page means the free value was delivered.
    // Normalizing here also repairs events queued by an older cached producer.
    if (event.page === FREE_TAROT_PAGE && event.readingMode === 'free_tarot'
      && FREE_TAROT_VALUE_EVENTS[event.eventName] && !metadata.free_value_status) {
      metadata.free_value_status = 'delivered';
    }
    return event;
  }

  function read() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      var cutoff = Date.now() - MAX_AGE_MS;
      return parsed.filter(function (item) {
        return item && item.event && item.event.eventId && item.createdAt >= cutoff && item.attempts < MAX_ATTEMPTS;
      }).map(function (item) {
        item.event = normalizeEvent(sanitizeEvent(item.event));
        return item;
      }).filter(function (item) { return item.event && item.event.eventId; }).slice(-MAX_EVENTS);
    } catch (_) { return []; }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify((items || []).slice(-MAX_EVENTS)));
      return true;
    } catch (_) { return false; }
  }

  function signal(status, detail) {
    var safe = {
      status: String(status || 'unknown'),
      queue_size: Math.max(0, Number(detail && detail.queue_size) || 0),
      http_status: Math.max(0, Number(detail && detail.http_status) || 0),
      rejected_count: Math.max(0, Number(detail && detail.rejected_count) || 0),
      error_code: String(detail && detail.error_code || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '_').slice(0, 64),
      reason: String(detail && detail.reason || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '_').slice(0, 64)
    };
    try { document.dispatchEvent(new CustomEvent('deckaura:funnel-delivery', { detail: safe })); } catch (_) {}
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('set', 'funnel_delivery_status', safe.status);
      if (safe.http_status) window.clarity('set', 'funnel_delivery_http_status', String(safe.http_status));
      if (safe.reason) window.clarity('set', 'funnel_delivery_reason', safe.reason);
      if (status === 'failed') window.clarity('event', 'funnel_delivery_failed');
      else if (status === 'rejected') window.clarity('event', 'funnel_event_rejected');
    } catch (_) {}
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(flush, Math.max(0, Number(delay) || 0));
  }

  function batchFor(items) {
    var now = Date.now();
    var ready = items.filter(function (item) { return !item.nextAt || item.nextAt <= now; });
    if (!ready.length) return [];
    var visitorId = ready[0].visitorId;
    return ready.filter(function (item) { return item.visitorId === visitorId; }).slice(0, 20);
  }

  function retryableStatus(status) {
    status = Number(status) || 0;
    return !status || status === 408 || status === 429 || status >= 500;
  }

  function responseReason(payload, status) {
    return String(payload && (payload.errorCode || payload.error) || ('http_' + (Number(status) || 0)))
      .toLowerCase().replace(/[^a-z0-9_-]+/g, '_').slice(0, 64);
  }

  function sendBatch(batch) {
    return fetch(ENDPOINT, {
      method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ visitorId: batch[0].visitorId, events: batch.map(function (item) { return item.event; }) })
    }).then(function (response) {
      return response.text().catch(function () { return ''; }).then(function (body) {
        var payload = {};
        try { payload = body ? JSON.parse(body) : {}; } catch (_) {}
        return { ok: response.ok, status: response.status, payload: payload };
      });
    });
  }

  function outcomeFor(batch, result) {
    var ids = batch.map(function (item) { return item.event.eventId; });
    if (result.ok && result.payload && result.payload.limited === true) {
      return { delivered: [], rejected: [], retry: ids, status: 429, reason: 'rate_limited' };
    }
    if (result.ok) {
      var explicitRejected = Array.isArray(result.payload && result.payload.rejectedEventIds)
        ? result.payload.rejectedEventIds.map(String) : [];
      var rejected = {};
      explicitRejected.forEach(function (id) { rejected[id] = true; });
      return {
        delivered: ids.filter(function (id) { return !rejected[id]; }),
        rejected: ids.filter(function (id) { return !!rejected[id]; }),
        retry: [], status: result.status,
        reason: explicitRejected.length ? responseReason(result.payload, result.status) : ''
      };
    }
    return {
      delivered: [], rejected: retryableStatus(result.status) ? [] : ids,
      retry: retryableStatus(result.status) ? ids : [], status: result.status,
      reason: responseReason(result.payload, result.status)
    };
  }

  function mergeOutcomes(outcomes) {
    return outcomes.reduce(function (merged, current) {
      merged.delivered = merged.delivered.concat(current.delivered || []);
      merged.rejected = merged.rejected.concat(current.rejected || []);
      merged.retry = merged.retry.concat(current.retry || []);
      if (!merged.status && current.status) merged.status = current.status;
      if (!merged.reason && current.reason) merged.reason = current.reason;
      return merged;
    }, { delivered: [], rejected: [], retry: [], status: 0, reason: '' });
  }

  function deliver(batch) {
    return sendBatch(batch).then(function (result) {
      if (result.ok || retryableStatus(result.status) || batch.length === 1) return outcomeFor(batch, result);
      // A deterministic 4xx can be caused by one stale producer. Isolate it so
      // one bad event never prevents valid events in the same outbox from landing.
      return Promise.all(batch.map(function (item) {
        return sendBatch([item]).then(function (singleResult) { return outcomeFor([item], singleResult); })
          .catch(function () { return { delivered: [], rejected: [], retry: [item.event.eventId], status: 0, reason: 'network' }; });
      })).then(mergeOutcomes);
    }).catch(function () {
      return { delivered: [], rejected: [], retry: batch.map(function (item) { return item.event.eventId; }), status: 0, reason: 'network' };
    });
  }

  function flush() {
    if (active) return;
    var batch = batchFor(read());
    if (!batch.length) return;
    active = true;
    var nextDelay = -1;
    deliver(batch).then(function (outcome) {
      var removed = {}, retried = {};
      outcome.delivered.concat(outcome.rejected).forEach(function (id) { removed[id] = true; });
      outcome.retry.forEach(function (id) { retried[id] = true; });
      var retained = [];
      var dropped = 0;
      read().forEach(function (item) {
        if (removed[item.event.eventId]) return;
        if (!retried[item.event.eventId]) { retained.push(item); return; }
        item.attempts = (Number(item.attempts) || 0) + 1;
        if (item.attempts >= MAX_ATTEMPTS) { dropped += 1; return; }
        item.nextAt = Date.now() + (item.attempts === 1 ? 750 : 2500);
        retained.push(item);
      });
      write(retained);
      if (dropped) signal('failed', { queue_size: retained.length, http_status: outcome.status, error_code: 'delivery_attempts_exhausted', reason: outcome.reason });
      else if (outcome.rejected.length) signal('rejected', { queue_size: retained.length, http_status: outcome.status, rejected_count: outcome.rejected.length, error_code: 'delivery_nonretryable_http', reason: outcome.reason });
      else if (outcome.retry.length) signal('retrying', { queue_size: retained.length, http_status: outcome.status, error_code: outcome.status === 429 ? 'delivery_rate_limited' : 'delivery_retry_scheduled', reason: outcome.reason });
      else signal('delivered', { queue_size: retained.length, http_status: outcome.status });
      if (outcome.retry.length && retained.length) nextDelay = 2600;
    }).finally(function () {
      active = false;
      if (nextDelay >= 0) schedule(nextDelay);
      else if (batchFor(read()).length) schedule(0);
    });
  }

  function directSend(visitorId, event) {
    var batch = [{ visitorId: visitorId, event: event }];
    sendBatch(batch).then(function (result) {
      var outcome = outcomeFor(batch, result);
      if (outcome.retry.length) signal('failed', { queue_size: 0, http_status: outcome.status, reason: outcome.reason });
      else if (outcome.rejected.length) signal('rejected', { queue_size: 0, http_status: outcome.status, rejected_count: outcome.rejected.length, reason: outcome.reason });
      else signal('delivered', { queue_size: 0, http_status: outcome.status });
    }).catch(function () { signal('failed', { queue_size: 0, http_status: 0, reason: 'network' }); });
  }

  function enqueue(input) {
    input = input || {};
    var event = normalizeEvent(sanitizeEvent(input.event));
    var visitorId = String(input.visitorId || '');
    if (!event || !event.eventId || !/^[a-zA-Z0-9_-]{16,96}$/.test(visitorId)) return false;
    var items = read();
    if (items.some(function (item) { return item.event.eventId === event.eventId; })) return true;
    items.push({ event: event, visitorId: visitorId, createdAt: Date.now(), attempts: 0, nextAt: 0 });
    if (!write(items)) { directSend(visitorId, event); return true; }
    schedule(0);
    return true;
  }

  function beacon() {
    var batch = batchFor(read());
    if (!batch.length) return;
    var body = JSON.stringify({ visitorId: batch[0].visitorId, events: batch.map(function (item) { return item.event; }) });
    /* Backend /funnel-events yalnizca application/json kabul ediyor; text/plain sendBeacon her
       pagehide'da 415 aliyordu ve checkout aninda kuyruktaki olaylar kayboluyordu (2026-09-03).
       keepalive fetch, sayfa kapanirken de JSON olarak teslim eder; fetch yoksa eski yola duser. */
    try {
      if (typeof fetch === 'function') {
        fetch(ENDPOINT, {
          method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: body
        }).catch(function () {});
        return;
      }
    } catch (_) {}
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
    } catch (_) {}
  }

  window.DeckauraFunnelDelivery = Object.freeze({ version: 'funnel-delivery-v2', enqueue: enqueue, flush: flush });
  window.addEventListener('online', flush);
  window.addEventListener('pagehide', beacon);
  var pending = Array.isArray(window.DeckauraFunnelDeliveryQueue) ? window.DeckauraFunnelDeliveryQueue.splice(0) : [];
  pending.forEach(enqueue);
  schedule(0);
})();
